import DB from './DB'

const filterKeys = {
  'storeid': 'storeid',
  'city': 'city',
  'district': 'district',
  'channel': 'channel',
  'signable': 'signable'
}

class StoreDB extends DB {
  constructor(array = [], options) {
    super(array, filterKeys, options)
  }

  filter(filter, $or, isOnlyDelivery = false) {
    if (isOnlyDelivery) filter['signable'] = true
    return super.filter(filter, $or)    
  }
}

export default StoreDB